import axios from "axios";
import { BASE_ENDPOINT } from "../helpers/Config";

const LEADER_REPORT_STATISTICS_URL = `${BASE_ENDPOINT}/admin/leader-report/statistics`;

/** @type {import("../types/leaderReportList").LEADER_REPORT_LIST_ENDPOINTS} */
const LEADER_REPORT_LIST_ENDPOINTS = {
    trade: `${BASE_ENDPOINT}/admin/leader-report/trade/list`,
    "first-deposit": `${BASE_ENDPOINT}/admin/leader-report/first-deposit/list`,
    "normal-deposit": `${BASE_ENDPOINT}/admin/leader-report/normal-deposit/list`,
    withdrawal: `${BASE_ENDPOINT}/admin/leader-report/withdrawal/list`,
};

/**
 * POST /admin/leader-report/statistics
 * @param {{ token: string, username: string, from_date: string, to_date: string }} params
 * @returns {Promise<import("../types/leaderReportStatistics").LeaderReportStatisticsResponse | import("../types/leaderReportStatistics").LeaderReportStatisticsErrorResponse>}
 */
export async function fetchLeaderReportStatistics({ token, username, from_date, to_date }) {
    const res = await axios({
        method: "post",
        url: LEADER_REPORT_STATISTICS_URL,
        headers: { "Content-Type": "application/json" },
        data: { token, username, from_date, to_date },
    });
    return res?.data;
}

/**
 * POST leader-report list endpoints (trade, first-deposit, normal-deposit, withdrawal)
 * @param {import("../types/leaderReportList").LeaderReportListVariant} variant
 * @param {import("../types/leaderReportList").LeaderReportListParams} params
 */
export async function fetchLeaderReportList(variant, params) {
    const url = LEADER_REPORT_LIST_ENDPOINTS[variant];
    if (!url) throw new Error(`Unknown list variant: ${variant}`);

    const res = await axios({
        method: "post",
        url,
        headers: { "Content-Type": "application/json" },
        data: {
            token: params.token,
            username: params.username,
            from_date: params.from_date,
            to_date: params.to_date,
            page_no: params.page_no,
            limit: Math.min(100, Math.max(1, params.limit || 20)),
            search: params.search ?? "",
            level: params.level,
        },
    });
    return res?.data;
}
